import { render, staticRenderFns } from "./ModalDrawing.vue?vue&type=template&id=3c5815be&"
import script from "./ModalDrawing.vue?vue&type=script&lang=js&"
export * from "./ModalDrawing.vue?vue&type=script&lang=js&"
import style0 from "./ModalDrawing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports